import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import dealersActions from '../../redux/dealers/actions';
import groupActions from '../../redux/groups/actions';
import DealerList from '../../components/DealerList';
import SidebarContainer from '../SidebarContainer';
import DealerService from '../../services/DealerService';
import './Dealers.scss';

class Dealers extends Component {
  constructor() {
    super();
    this.state = {
      groupsMap: {},
    };
  }

  componentDidMount() {
    this.props.actions.resetDealer();
    this.props.actions.dealersRequest({
      addExtraInformation: false,
    });
    this.props.actions.groupsRequest();
    if (this.props.groups.length > 0) {
      const groupsMap = {};
      this.props.groups.forEach(({ id, name }) => {
        groupsMap[id] = name;
      });
      this.setState({
        groupsMap,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.groups !== this.props.groups &&
      this.props.groups.length > 0
    ) {
      const groupsMap = {};
      this.props.groups.forEach(({ id, name }) => {
        groupsMap[id] = name;
      });
      this.setState({
        groupsMap,
      });
    }
  }

  validateDealer = (dealer) => {
    DealerService.validateDealer(dealer.id).then(() => {
      this.props.actions.dealersRequest({
        addExtraInformation: this.state.addExtraInformation,
      });
    });
  };

  runAutomation = (dealer, type = 'papyrus') => {
    DealerService.runAutomation(dealer.id, type).then(
      () => {
        this.props.actions.dealersRequest({
          addExtraInformation: this.state.addExtraInformation,
        });
      },
      () => {
        this.props.actions.dealersRequest({
          addExtraInformation: this.state.addExtraInformation,
        });
      },
    );
  };

  cancelValidate = (dealer) => {
    DealerService.cancelValidation(dealer.id).then(
      () => {
        this.props.actions.dealersRequest({
          addExtraInformation: this.state.addExtraInformation,
        });
      },
      () => {
        this.props.actions.dealersRequest({
          addExtraInformation: this.state.addExtraInformation,
        });
      },
    );
  };

  editDealer = async (dealerId) => {
    this.props.history.push(`/dealer/${dealerId}`);
  };

  render() {
    const { actions, dealers } = this.props;
    return (
      <SidebarContainer
        title="Dealership Manager"
        openSubMenu="Client Management"
      >
        <div className="dealers-table">
          <DealerList
            list={dealers.dealers}
            error={dealers.error}
            success={dealers.success}
            fetching={dealers.fetching}
            onDelete={actions.deleteDealerRequest}
            onInventoryImport={actions.inventoryImportRequest}
            onValidate={this.validateDealer}
            runAutomation={this.runAutomation}
            onCancel={this.cancelValidate}
            editDealer={this.editDealer}
            groupsMap={this.state.groupsMap}
            onAddExtraInformation={(dealerId) =>
              this.props.actions.dealerStatusRequest({ dealerId })
            }
          />
        </div>
      </SidebarContainer>
    );
  }
}

Dealers.propTypes = {
  dealers: PropTypes.object,
  actions: PropTypes.object,
  groups: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = ({ dealers, groups }) => ({
  dealers,
  groups: groups.groups,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...dealersActions,
      ...groupActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dealers);
